function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import produce from 'immer';
import React, { useEffect, useMemo, useState } from 'react';
import { InputReact } from 'common/components/input';
import { InputSize, InputType, ValidationStatus } from 'common/components/input/types';
import { MetricEntry } from 'common/query-builder/query-entry-section/types';
import { getFormulaValidationError } from 'common/report/insights/contexts/formula-utils';
import { getAlphaLabelFromIndex } from 'common/util';
import { KEY_VALUES } from 'common/util/dom';

// eslint-disable-next-line import/no-cycle
import { NewMetricEntry } from '../..';
import type { RowProps } from '../catalog';
import styles from './index.module.styl';
export function FormulaDefinition(props: RowProps) {
  var _props$entry$referenc, _props$entry$referenc2;
  const [formulaDefinition, setFormulaDefinition] = useState(props.entry.definition);
  useEffect(() => {
    setFormulaDefinition(props.entry.definition);
  }, [props.entry.definition]);
  const formulaError = useMemo(() => getFormulaValidationError({
    metric: props.entry,
    definition: formulaDefinition,
    globalMetrics: props.getEntries(false) as MetricEntry[]
  }), [props.getEntries().length, formulaDefinition, (_props$entry$referenc = (_props$entry$referenc2 = props.entry.referencedMetrics) === null || _props$entry$referenc2 === void 0 ? void 0 : _props$entry$referenc2.length) !== null && _props$entry$referenc !== void 0 ? _props$entry$referenc : 0]);
  const onDefinitionCommit = (newDefinition: string) => {
    if (newDefinition && props.entry.definition !== newDefinition) {
      props.updateEntry(_objectSpread(_objectSpread({}, props.entry), {}, {
        definition: newDefinition
      }));
    }
  };

  /** commits the formula on Enter */
  const handleDefinitionKeydown = (ev: KeyboardEvent) => {
    const inputEl = ev.currentTarget as HTMLInputElement;
    if (ev.key === KEY_VALUES.ENTER) {
      ev.preventDefault();
      inputEl.blur();
    } else if (ev.key === KEY_VALUES.ESCAPE) {
      setFormulaDefinition(props.entry.definition);
      inputEl.blur();
    }
  };

  /** transforms the input to uppercase */
  const handleDefinitionInput = (ev: InputEvent) => {
    const inputEl = ev.currentTarget as HTMLInputElement;
    inputEl.value = inputEl.value.toUpperCase();
    setFormulaDefinition(inputEl.value);
  };
  const handleDefinitionBlur = (ev: FocusEvent) => {
    const inputEl = ev.currentTarget as HTMLInputElement;
    const newDefinition = inputEl.value;
    if (!newDefinition && props.entry.definition) {
      setFormulaDefinition(props.entry.definition);
    } else {
      onDefinitionCommit((ev.currentTarget as HTMLInputElement).value);
    }
  };
  const updateReferenceEntry = (index: number, entry: MetricEntry) => {
    props.updateEntry(produce(props.entry, draft => {
      draft.referencedMetrics[index] = entry;
    }));
  };
  const removeReferenceEntry = (index: number) => {
    props.updateEntry(produce(props.entry, draft => {
      draft.referencedMetrics.splice(index, 1);
    }));
  };
  const addReferenceEntry = (index: number, entry: MetricEntry) => {
    props.updateEntry(produce(props.entry, draft => {
      draft.referencedMetrics.splice(index + 1, 0, entry);
    }));
  };
  return <div className={styles.formula} data-sentry-component="FormulaDefinition" data-sentry-source-file="definition.tsx">
      <div className={styles.referencedMetrics}>
        {/* for saved formulas, renders metrics involved in the formula definition */}
        {Array.isArray(props.entry.referencedMetrics) && props.entry.referencedMetrics.map((entry, metricIndex) => <NewMetricEntry {...props} disableHideEntry isExpanded={false} parentMetricIndex={props.index} entry={entry} index={metricIndex} updateEntry={metricEntry => updateReferenceEntry(metricIndex, metricEntry)} cloneEntry={metricEntry => addReferenceEntry(metricIndex, metricEntry)} removeEntry={props.entry.referencedMetrics.length > 1 ? () => removeReferenceEntry(metricIndex) : null} rowLabel={getAlphaLabelFromIndex(metricIndex)} />)}
      </div>

      {/* formula definition, i.e. A / B * 100 */}
      <div className={styles.definition}>
        <InputReact className={styles.input} elref='formulaDefinition' type={InputType.Text} size={InputSize.Medium} placeholder='eg. (A+B)/(A-B) * 100' autoFocus={props.entry.definition === ""} {...formulaError && {
        validationStatus: ValidationStatus.Invalid,
        errorMessage: formulaError
      }} value={formulaDefinition} onKeydown={handleDefinitionKeydown} onInput={handleDefinitionInput} onBlur={handleDefinitionBlur} data-sentry-element="InputReact" data-sentry-source-file="definition.tsx" />
      </div>
    </div>;
}